import axios from 'axios';

export default {
  data() {
    return {
      delivery_address: '',
      address_data: '',
      purse_id: '',
      valid: false,
      rules: {
        required: value => !!value || 'Поле должно быть заполнено',
      },
      suggestions: [],
      suggestions_items: [],
      search: '',
    };
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    balance() {
      return this.$store.state.user.balance * 1;
    },
    userHasPassport() {
      return this.user && this.user.account && this.user.account.status === 'approved';
    },
    loading() {
      return this.$store.state.loading;
    },
    cart() {
      return this.$store.state.shop.cart;
    },
    epsCartLength() {
      return this.$store.state.eps.cartLength;
    },
  },
  methods: {
    checkLimits(product) {
      return (product.limits[product.size] && product.limits[product.size] >= product.qty) ? true : 'Нет выбранного количества';
    },
    async ChangeQty(product) {
      if (+product.qty <= 0) {
        await this.RemoveProduct(product.id);
        return;
      }
      this.$store.dispatch('shop/ChangeQty', { product });
    },
    async ChangeSize(product) {
      this.$store.dispatch('shop/ChangeQty', { product });
    },
    async RemoveProduct(id) {
      await this.$store.dispatch('shop/RemoveProduct', { id });
    },
    async SendOrder() {
      const app = this;
      const payload = {
        profile_id: app.user.profile_id,
        phone_mobile: app.user.phone_mobile,
        email: app.user.email,
        delivery_address: app.delivery_address,
        items: app.cart.products.map(product => ({
          id: product.id,
          qty: product.qty,
          size: product.size,
        })),
      };
      app.$store.getters.axl.post('shop/api-v3/order/create', payload)
        .then(() => {
          this.$store.dispatch('shop/ClearCart');
          this.$store.dispatch('shop/ShowInfoMessage', 'Товары заказаны', { root: true });
          app.$router.push({ path: '/orders', query: { activeTab: 2 } });
        })
        .catch((error) => {
          app.$store.dispatch('HandleError', error);
        })
        .finally(() => {
          app.isLoad = false;
        });
    },
    async AutocompleteSearch(queryString) {
      queryString = this.search;
      if (!queryString) return;
      const app = this;
      const info = { count: 20, query: queryString };
      this.isLoadingSuggest = true;
      const config = {
        headers: {
          Accept: 'application/json, text/javascript, */*; q=0.01',
          Authorization: 'Token 7a77efb8ab6dae6e380c7e438b85360185660f34',
          'Content-Type': 'application/json',
        },
      };

      await axios.post('https://dadata.ru/api/v2/suggest/address', info, config)
        .then((res) => {
          app.suggestions = res.data.suggestions;
        })
        .catch((err) => {
          console.log(err);
        }).finally(() => {
          this.isLoadingSuggest = false;
        });
    },
    AutocompleteSelect(value) {
      this.suggestions.forEach((sug) => {
        if (sug.value === value) {
          this.user.region_kladr_id = sug.data.region_kladr_id;
          this.user.region_fias_id = sug.data.region_fias_id;
        }
      });
    },
  },
  created() {
  },
};
